export default __webpack_public_path__ + "e65a2020499e4fe4db422844296c7c70.png";